import angular from 'angular';
import angularUiBootstrap from 'angular-ui-bootstrap';
import {EmailDesignService} from './email-design.service';

export default angular.module('slViz.emailDesignModule', [
    angularUiBootstrap
])
    .service('EmailDesignService', EmailDesignService)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/email-design/index.js